import { nullableString } from './wire-value-utils';

/** A read-only text field of a hub record: the string as sent, else `null`. Never for writable fields. */
export function textOrNull(source: Record<string, unknown>, key: string): string | null {
  return nullableString(source[key]) ?? null;
}
